import { useQuery, UseQueryResult, QueryFunctionContext } from '@tanstack/react-query'
import DepartureService, { Voucher } from '../services/departures'
import { useMemo } from 'react'

export class NotFoundError extends Error {}

async function fetchVoucher ({ queryKey: [,departureId, , voucherCode] }: QueryFunctionContext<[string, string, string, string]>): Promise<Voucher> {
  const departureService = new DepartureService()
  if (departureId === '') {
    throw new NotFoundError()
  }
  if (voucherCode === '') {
    throw new NotFoundError()
  }
  const voucher = await departureService.voucher(departureId, voucherCode)
  return voucher
}

export function useVoucher (departureId: string, voucherCode: string): UseQueryResult<Voucher> {
  const query = useQuery(
    ['departure', departureId, 'voucher', voucherCode],
    fetchVoucher
  )
  return query
}

export function useDiscount (totalCabinPrice: number, totalPassengers: number, voucher?: Voucher): number {
  return useMemo(() => {
    if (voucher === undefined) {
      return 0
    }
    const discountAmount = voucher.discount_type === 'Discount Percentage' ? (voucher.percentage ?? 0) * totalCabinPrice / 100 : (voucher.amount ?? 0) * totalPassengers
    return Math.min(totalCabinPrice, discountAmount)
  }, [totalCabinPrice, totalPassengers, voucher])
}
